function maLogInicio(response) {
  let valor = false;
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.reinicio === 'si') {
    const accionStore = 'setReiniciar';
    valorCambiaPanelLateral = 0;
    valor = true;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.inicio_chat === 'si') {
    const accionStore = 'setInicioChat';
    valorCambiaPanelLateral = 0;
    valor = true;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maLogVolverMenu(response) {
  let valor = false;
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.reinicio === 'si') {
    const accionStore = 'setReiniciar';
    valorCambiaPanelLateral = 0;
    valor = true;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.inicio_chat === 'si') {
    const accionStore = 'setInicioChat';
    valorCambiaPanelLateral = 0;
    valor = true;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maLogBuscarPacienteCedula(response) {
  let valor = Number;
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.ver_usuario === 'si') {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 0;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.paciente) {
    const accionStore = 'setNombrePaciente';
    valorCambiaPanelLateral = 0;
    valor = response.paciente;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maLogBuscarPaciente(response) {
  const accionStore = 'setCedulaPaciente';
  let valor = Number;
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.ver_usuario === 'si') {
    valorCambiaPanelLateral = 0;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.paciente) {
    const accionStore = 'setNombrePaciente';
    valorCambiaPanelLateral = 0;
    valor = response.paciente;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}

function maLogCheckpoint(response) {
  let valor = Number;
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.checkpoint === 'si') {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 5;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.checkpoint === 'si') {
    const accionStore = 'setCheckpoint';
    valorCambiaPanelLateral = 5;
    valor = response.checkpoint;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
    if (response.encuentro_id) {
      matrizActionValor.push({
        accionStore: 'setId',
        valor: response.encuentro_id,
      });
      matrizActionValor.push({
        accionStore: 'setEncuentro',
        valor: response.encuentro,
      });
      matrizActionValor.push({
        accionStore: 'setMomentoActual',
        valor: response.momento,
      });
    } else if (response.evento === 'seguimientos') {
      valorCambiaPanelLateral = 8;
      matrizActionValor.push({
        accionStore: 'setId',
        valor: response.id,
      });
      matrizActionValor.push({
        accionStore: 'setNombreEvento',
        valor: response.nombreEvento,
      });
      matrizActionValor.push({
        accionStore: 'setColeccion',
        valor: response.evento,
      });
    }
  }
  if (response.checkpoint === 'no') {
    const accionStore = 'setCheckpoint';
    valorCambiaPanelLateral = 0;
    valor = response.checkpoint;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  // if (response.nombre_formulario) {
  //   const accionStore = 'setNombreFormulario';
  //   valorCambiaPanelLateral = 5;
  //   valor = response.nombre_formulario;
  //   jsonActionValor = {
  //     valor,
  //     accionStore,
  //   };
  //   matrizActionValor.push(jsonActionValor);
  //   console.log('cedula', matrizActionValor, accionStore);
  // }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maLogPass(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  const accionStore = 'setLogHistoriaClinica';
  if (response.response == 'Ok, estoy disponible para responder tus preguntas de registro y gestión') {
    valorCambiaPanelLateral = 1;
    valor = true;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } else {
    valorCambiaPanelLateral = 0;
    valor = true;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
module.exports.loginEstados = function loginEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_log_inicio':
        resolve(maLogInicio(response));
        break;
      case 'ma_log_buscar_paciente_cedula':
        resolve(maLogBuscarPacienteCedula(response));
        break;
      case 'ma_log_pass':
        resolve(maLogPass(response));
        break;
      case 'ma_log_checkpoint':
        resolve(maLogCheckpoint(response));
        break;
      case 'ma_log_buscar_paciente':
        resolve(maLogBuscarPaciente(response));
        break;
      case 'ma_log_volver_menu':
        resolve(maLogVolverMenu(response));
        break;
      default:
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modulosChatBox/login.js